import { Injectable } from "@angular/core";
import { DataService } from "../data.service";

@Injectable({
  providedIn: "root",
})
export class MedicalRecordIntegrationService {
  constructor(private dataService: DataService) {}

  private readonly publishEndPoint: string =
    "/medicalRecordIntegration/open/";

  async open(
    medicalAppointmentId: number,
    isServiceCare: boolean
  ): Promise<string> {
    const params = {
      MedicalAppointmentId: medicalAppointmentId,
      IsServiceCare: isServiceCare,
    };
    return await this.dataService
      .post<string>(this.publishEndPoint, params)
      .toPromise();
  }
}
